import {useTranslation} from "react-i18next"
import {useNwDashboardContext} from "../../reactContext/contextCustomHooks/useNwDashboardContext"
import useTeams from "../../swrCustomHooks/useTeams"
import TeamCard from "../../components/team-card/TeamCard"
import LoadingComponent from "../../components/loading-component/LoadingComponent"
import openRedFolderIcon from "../../assets/icon/open-red-folder.svg"
import plusIcon from "../../assets/icon/plus.svg"

export default function NeurowideDashboardContent() {
    const {t} = useTranslation()
    const {setNwDashboardAction} = useNwDashboardContext()
    const {teams, isLoadingTeams, isErrorTeams} = useTeams()
    if (isErrorTeams || isLoadingTeams || teams.message) return <LoadingComponent/>
    return (
        <>
        <div className="SECTION NEUROWIDE-DASHBOARD-CONTENT">
            <h2><img src={openRedFolderIcon} alt=""/>{t("LICENCES")}</h2>
            <button className="add-team-btn" onClick={() => setNwDashboardAction({type: "NW_DASHBOARD_IS_MODAL", payload: {isModal: true}})}><img src={plusIcon} alt=""/>{t("Add")}</button>
            <div className="teams">
                {teams.map((team, index) => (
                    <TeamCard key={`team-${index}`} team={team}/>
                ))}
            </div>
        </div>
        </>
    )
}